import * as Yup from "yup";
import constants from "../../common/constants";

export const OrderSummarySchema = Yup.object({
  DocumentType: Yup.string()    
    .test("DocumentType", "* This field is required", (value, context) => {      
      if (context.parent.hdnTab === "2")
        return value && value !== "0";
        else
        return true;
    }),
  Property: Yup.string()
    //.required("* This field is required")
    .test("Property", "* This field is required", (value, context) => {
      if (context.parent.hdnTab === "2")
        return value && value !== "0";
        else
        return true;
    }),
  DocumentPackage: Yup.string().required("* This field is required"),
  //emailID: Yup.array().min(1)
  // email: Yup.string()
  //   .required("RequiredFieldErrMsg")
  //   .matches(constants.EmailRegex.isEmailRegx, "InvalidEmailErrMsg"),
  
  
  
});
